/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { matchPath, useLocation } from "react-router"

import { AppRoutes } from "../routes/routes"

// Function uses react router matching to fit current route
// as fit of AppRoutes enum value.
export const useActiveRoute = (): AppRoutes | null => {
    const location = useLocation()
    return Object.values(AppRoutes).find((route) => matchPath(route, location.pathname)) ?? null
}
